import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { js_utils } from "../utils/frfr-js-utils";
import { _virbom_manipulator } from "../utils/frfr-virbom-manipulator-utils";
import { virbomCounter } from "../utils/frfr-virbom-counter-utils";
import { derAutoCreateVirbom_terkk_kucisteelektrogrejaca_children, derAutoCreateVirbom_terkk_kucisteelektrogrejaca_prepare_vir_input } from "./ter-derivat-lib-terkk-kucisteelektrogrejaca";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from "./ter-protobomp-utils";


// TER DRAFTEL CODECS LIB

/*
kucisteelektrogrejaca u izradi

- 

TODO:
- 




*/


export const draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca = {};


// ---------- CODEC SCHEMA METHODS ----------


draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_kucisteelektrogrejaca',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    _protobomp: protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$kucisteelektrogrejaca"), null),

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input

    kelg_kolikoredova: null,
    kelg_kolikogrejacapovisini: null,
    kelg_rak_termostat: null,
    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_pods_input_state = () => {
  return default_pods_input_state_smart_get('terkk$kucisteelektrogrejaca');
};


draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_kucisteelektrogrejaca_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default


    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input // ove su proverene 2023-09-23
  // tipkomore: virtel_k.tipkomore,
  // ksirinaoznaka: virtel_k.ksirinaoznaka,
  // kvisinaoznaka: virtel_k.kvisinaoznaka,
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_subform_item_preset_state())
];


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------


draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.subDrafel_to_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima

};


draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.bundleDrafel_to_paired_virtel = (formState) => {
  // pretvara iz formState u virtel format sa ispravnim flagovima
  const sema = virtel_schema_smart_get('terkk$kucisteelektrogrejaca');
  console.log(formState);
  let state = {
    ...formState
  };
  const p = state;
  const kucisteelektrogrejacaNaziv = '? PPV ?';
  p.naziv = kucisteelektrogrejacaNaziv;
  //
  const _params = {
    "operacija": "OPSKL",
    "rc": "RCDE",
  };
  const virtel = {
    ...p,
    virtelschemakey: 'terkk$kucisteelektrogrejaca',
    paired_with_smartel: true,
    ..._get_fixed_fields(sema),
    ..._params,
    ..._getParamsFromLib("terkk$kucisteelektrogrejaca") // parametri na kraju imaju prioritet
  };
  return virtel; // return virtel
};


/////////


draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.bundleDraftel_to_unbundled_subDraftel_arr = (bundleDraftel) => {
  // draftel single BUNDLE to draftel array
  const bundle = bundleDraftel;
  let _unbundled_subDraftel_arr = [];
  const zajednicki_higher_props_za_items = {
    // meta
    parent_subkey: bundle.parent_subkey,
    superkey: bundle.superkey,
    // bundle_id: p.bundle_id,
    // od poluproizvoda

    // pods_input TODO Da li treba bolje resenje?
    flag_custom_pods_input: bundle.flag_custom_pods_input,
  };
  if (Array.isArray(bundle._subform_arr)) {
    bundle._subform_arr.forEach(elk_raw => {
      let draftel_elk = {
        ...draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_preset_state(),
        ...elk_raw,
        ...zajednicki_higher_props_za_items
      };
      _unbundled_subDraftel_arr.push(draftel_elk);
    });
  };
  return _unbundled_subDraftel_arr;
};


draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.bundleDrafel_to_virbom = (bundleDraftel) => {
  // MAIN CONVERT METHOD
  // const sema = virtel_schema_smart_get('terkk$kucisteelektrogrejaca');

  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);

  const paired_virtel = draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.bundleDrafel_to_paired_virtel(bundleDraftel);

  const local_graphlevel = 1;
  _virbom_manipulator.add_as_first_virtel(virbom_ref, paired_virtel);

  // KORAK DODAVANJE CHILDRENA OD paired_virtel-a

  let pods_input_za_derivate = derAutoCreateVirbom_terkk_kucisteelektrogrejaca_prepare_vir_input(paired_virtel); // ??? 
  let _der_virtel_children = derAutoCreateVirbom_terkk_kucisteelektrogrejaca_children(pods_input_za_derivate);
  console.log('_der_virtel_children', _der_virtel_children);
  // USISAVANJE
  _virbom_manipulator._merge_virbom_into_virbom_on_graphlevel(virbom_ref, _der_virtel_children, local_graphlevel + 1, virbomCounter.generateFreshSubkey);

  // ZAVRSENI KORACI ZA JEDAN pp3
  // ***ZAVRSENI KORACI ZA JEDAN pp3

  // ZAVRSENI KORACI ZA JEDAN pp3

  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  return virbom_seq; // return virbom
};


// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING


/*
draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.virtel_to_subDraftel = (virtel) => {
  // pretvara iz virtela u formState format
  //
  let state = {
    ...draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.default_subform_item_preset_state(),
    ...js_utils.clone_obj_but_only_selected_keys(virtel, draftel_codecs_pack_terkk$_bundle_kucisteelektrogrejaca.keys_for_direct_cloning)
  };
  //
  return state;
};
*/

